import axios from "axios";
import { API_BASE_URL, FETCH_LIMIT } from "../../globalVars";

export default {
  namespaced: true,

  actions: {
    async hydrate({ commit }) {
      const store = this;
      const last = this.getters["entities/settings/query"]().first()
        .lastUpdateFromServer;
      await fetchNext({
        store: store,
        offset: 0,
        lastDateTime: last
      });
    },

    async createBizReviewSettings(context, bizReviewSettings) {
      if (bizReviewSettings.isDirty === true) {
        const store = this;
        try {
          let response = await axios({
            method: "post",
            url: API_BASE_URL + `/biz-review-settings/${bizReviewSettings.id}`,
            data: {
              accountId: bizReviewSettings.accountId,
              activeReviewTypes: bizReviewSettings.activeReviewTypes,
              // googlePlaceId: bizReviewSettings.googlePlaceId,
              // facebookPageId: bizReviewSettings.facebookPageId,
              // yelpPageId: bizReviewSettings.yelpPageId,
              config: bizReviewSettings.config
            },
            headers: {
              Authorization: `Bearer ${localStorage.getItem("access_token")}`
            }
          });
          store.dispatch("entities/bizReviewSettings/delete", {
            where: bizReviewSettings.tempId
          });
          store.dispatch("entities/bizReviewSettings/update", {
            where: response.id,
            data: {
              isDirty: false,
              createdAt: Date.parse(response.createdAt),
              updatedAt: Date.parse(response.updatedAt)
            }
          });
          store.dispatch("entities/settings/setIsOffline", false);
        } catch (error) {
          store.dispatch("entities/settings/setIsOffline", true);
        }
      }
    },

    async updateBizReviewsSettings(context, bizReviewSettings) {
      if (bizReviewSettings.isDirty === true) {
        const store = this;
        try {
          let response = await axios({
            method: "patch",
            url: API_BASE_URL + `/biz-review-settings/${bizReviewSettings.id}`,
            params: {
              id: bizReviewSettings.id
            },
            data: {
              id: bizReviewSettings.id,
              accountId: bizReviewSettings.accountId,
              activeReviewTypes: bizReviewSettings.activeReviewTypes,
              // googlePlaceId: bizReviewSettings.googlePlaceId,
              // facebookPageId: bizReviewSettings.facebookPageId,
              // yelpPageId: bizReviewSettings.yelpPageId,
              reviewCount: bizReviewSettings.reviewCount,
              reviewAvg: bizReviewSettings.reviewAvg,
              config: JSON.stringify(bizReviewSettings.config)
            },
            headers: {
              Authorization: `Bearer ${localStorage.getItem("access_token")}`
            }
          });
          store.dispatch("entities/bizReviewSettings/update", {
            where: response.data.id,
            data: {
              isDirty: false,
              createdAt: Date.parse(response.data.createdAt),
              updatedAt: Date.parse(response.data.updatedAt)
            }
          });
          store.dispatch("entities/settings/setIsOffline", false);
        } catch (error) {
          store.dispatch("entities/settings/setIsOffline", true);
        }
      }
    }
  }
};

async function fetchNext({ store, offset, lastDateTime = 0 }) {
  try {
    let response = await axios({
      method: "get",
      url:
        API_BASE_URL +
        `/biz-review-settings?updatedAt[$gt]=${lastDateTime}&$limit=${FETCH_LIMIT}&$skip=${offset}`,
      headers: {
        Authorization: `Bearer ${localStorage.getItem("access_token")}`
      }
    });
    const obj = response.data.data;
    const maxRows = response.data.total;
    let bizReviewSettings = [];
    obj.forEach(function(bizReviewSetting) {
      bizReviewSettings.push({
        id: bizReviewSetting.id,
        isDirty: false,
        accountId: bizReviewSetting.accountId,
        activeReviewTypes: bizReviewSetting.activeReviewTypes,
        // googlePlaceId: bizReviewSetting.googlePlaceId,
        // facebookPageId: bizReviewSetting.facebookPageId,
        // yelpPageId: bizReviewSetting.yelpPageId,
        reviewCount: bizReviewSetting.reviewCount,
        reviewAvg: bizReviewSetting.reviewAvg,
        config: bizReviewSetting.config,
        createdAt: Date.parse(bizReviewSetting.createdAt),
        updatedAt: Date.parse(bizReviewSetting.updatedAt)
      });
    });
    if (bizReviewSettings.length > 0) {
      store.dispatch("entities/bizReviewSettings/insert", {
        data: bizReviewSettings
      });
    }
    store.dispatch("entities/settings/setIsOffline", false);
    if (maxRows > FETCH_LIMIT + offset) {
      await fetchNext({
        store,
        offset: FETCH_LIMIT + offset,
        lastDateTime
      });
    }
  } catch (error) {
    store.dispatch("entities/settings/setIsOffline", true);
  }
}
